module.exports = __webpack_public_path__ + "img/card-boxer-multi.a203c59a.webp";